// 일정 리스트의 한 행. 날짜 칼럼(월/일) + 제목/메타 + 케밥/쉐브론.
//
// 케밥 메뉴는 legacy.ts의 모듈-로컬 상태(kebabMenuEl/Handler)에 의존하므로
// 컴포넌트가 직접 호출하지 않고 onKebab 콜백으로 위임한다.

import { isAdmin } from "../../auth";
import { navigate } from "../../routes";
import { parseDateParts, isKoreanHoliday, statusLabel, statusChipClass, eventKindLabel } from "../format";
import { Icon } from "./Icon";

interface EventRowCardProps {
  ev: any;
  onKebab: (anchor: HTMLElement) => void;
}

function dateClass(parts: ReturnType<typeof parseDateParts>, ev: any): string {
  const base = "event-row__date";
  if (parts.isToday) return `${base} ${base}--today`;
  if (isKoreanHoliday(ev.event_date) || parts.weekday === 0) return `${base} ${base}--sun`;
  if (parts.weekday === 6) return `${base} ${base}--sat`;
  return base;
}

export function EventRowCard({ ev, onKebab }: EventRowCardProps) {
  const parts = parseDateParts(ev.event_date);
  const hasKebabAction =
    isAdmin() && (
      ev.status === "draft" ||
      ev.status === "ready" ||
      ev.status === "completed" ||
      ev.status === "archived"
    );
  const metaSuffix = ev.location ? `· ${ev.location}` : `· ${eventKindLabel(ev)}`;
  return (
    <div
      class="card card--tap"
      onClick={() => navigate({ name: "event", id: ev.event_id })}
    >
      <div class="event-row">
        <div class={dateClass(parts, ev)}>
          <span class="month">{parts.month}</span>
          {parts.day ? <span class="day">{parts.day}</span> : null}
        </div>
        <div class="event-row__main">
          <h4 class="event-row__title">{ev.title || "(제목 없음)"}</h4>
          <p class="event-row__meta">
            <span class={statusChipClass(ev.status)}>{statusLabel(ev.status)}</span>
            {metaSuffix}
          </p>
        </div>
        {hasKebabAction ? (
          <button
            class="event-row__kebab"
            type="button"
            aria-label="더보기"
            onClick={(e: MouseEvent) => {
              e.stopPropagation();
              onKebab(e.currentTarget as HTMLElement);
            }}
          >
            <Icon name="more-vertical" size={18} />
          </button>
        ) : (
          <div class="event-row__chev">
            <Icon name="chevron" size={18} />
          </div>
        )}
      </div>
    </div>
  );
}
